import { StyledScreenFrame } from './ScreenFrameGrid.styled';

const ScreenFrameGrid = ({ children, gridRow = 1, gridColumn = 1, color = null}) => {
  return (
    <StyledScreenFrame $gridRow = {gridRow} $gridColumn = {gridColumn} $color={color}>
      <div className='scroller'>
        {children}
        <div className='screen-corner screen-corner-tl'/>
        <div className='screen-corner screen-corner-tr'/>
        <div className='screen-corner screen-corner-bl'/>
        <div className='screen-corner screen-corner-br'/>
      </div>
    </StyledScreenFrame>
  );
};

export default ScreenFrameGrid;
